import React from 'react';
import { Link } from 'react-router-dom';

const FeaturedProjects = () => {

  const smallProjects = [
    {
      id: 'glen_iris',
      image: '/images/projects/4.png',
      alt: 'Luxury  elevator interior, premium hospitality design, elegant finishes, sophisticated lighting',
      category: 'Residential',
      title: 'Glen Iris',
      description: 'Luxury elevator interior, premium design, elegant finishes, sophisticated lighting'
    },
    {
      id: 'balwyn',
      image: '/images/projects/1.jpg',
      alt: 'Modern elevators, retail architecture, contemporary design, busy commercial space',
      category: 'Residential',
      title: 'Balwyn',
      description: 'Modern elevators, residential architecture, contemporary design'
    },
    {
      id: 'brighton',
      image: '/images/projects/6.png',
      alt: 'Modern elevator system, healthcare facility, clean medical environment, luxury architecture',
      category: 'Residential',
      title: "Brighton",
      description: 'Modern elevator system, luxury architecture'
    }
  ];

  return (
    <section id="projects" className="py-24 bg-premium-gray">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-premium-gold text-sm font-semibold tracking-widest uppercase">Portfolio</span>
          </div>
          <h2 className="font-display text-5xl font-bold text-white mb-6">
            Featured Projects
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Discover how we've transformed vertical mobility for leading architectural projects worldwide
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {smallProjects.map((project, index) => (
            <Link 
              key={index} 
              to={`/project/${project.id}`}
              className="group relative overflow-hidden h-96 block"
            >
              <img
                src={project.image}
                alt={project.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-premium-dark via-premium-dark/50 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="text-xs font-semibold text-premium-gold tracking-widest mb-2 block">{project.category}</span>
                <h3 className="font-display text-2xl font-bold text-white mb-2">{project.title}</h3>
                <p className="hidden sm:block text-gray-300 text-sm mb-3">{project.description}</p>
                <span className="text-white text-sm font-semibold flex items-center space-x-2">
                  <span>View Project</span>
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
